import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import FolderView from "@/pages/FolderView";
import ClientDirectory from "@/pages/ClientDirectory";
import BuilderView from "@/pages/BuilderView";
import ProjectView from "@/pages/ProjectView";
import Team from "@/pages/Team";
import TasksView from "@/pages/TasksView";
import StudioBoard from "@/pages/StudioBoard";
import MyWeek from "@/pages/MyWeek";
import Templates from "@/pages/Templates";
import Settings from "@/pages/Settings";
import AuditLog from "@/pages/AuditLog";
import TimeReport from "@/pages/TimeReport";
import FeesReport from "@/pages/FeesReport";
import CRM from "@/pages/CRM";
import Consultants from "@/pages/Consultants";
import LibraryPage from "@/pages/Library";
import Files from "@/pages/Files";
import Layout from "@/components/Layout";

function Protected({ children, adminOnly }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="h-8 w-8 border-2 border-zinc-900 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  return <Layout>{children}</Layout>;
}

function AppRouter() {
  const location = useLocation();
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<Protected><Dashboard /></Protected>} />
      <Route path="/tasks" element={<Protected><TasksView /></Protected>} />
      <Route path="/board" element={<Protected><StudioBoard /></Protected>} />
      <Route path="/clients" element={<Protected><ClientDirectory /></Protected>} />
      <Route path="/my-week" element={<Protected><MyWeek /></Protected>} />
      <Route path="/folder/:category" element={<Protected><FolderView /></Protected>} />
      <Route path="/folder/:category/builder/:builderId" element={<Protected><BuilderView /></Protected>} />
      <Route path="/project/:projectId" element={<Protected><ProjectView /></Protected>} />
      <Route path="/team" element={<Protected adminOnly><Team /></Protected>} />
      <Route path="/templates" element={<Protected adminOnly><Templates /></Protected>} />
      <Route path="/settings" element={<Protected adminOnly><Settings /></Protected>} />
      <Route path="/audit" element={<Protected adminOnly><AuditLog /></Protected>} />
      <Route path="/time-report" element={<Protected adminOnly><TimeReport /></Protected>} />
      <Route path="/fees-report" element={<Protected><FeesReport /></Protected>} />
      <Route path="/crm" element={<Protected><CRM /></Protected>} />
      <Route path="/consultants" element={<Protected><Consultants /></Protected>} />
      <Route path="/library" element={<Protected><LibraryPage /></Protected>} />
      <Route path="/library/clip" element={<Protected><LibraryPage /></Protected>} />
      <Route path="/files" element={<Protected><Files /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-right" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
